<div [style.max-height]="maxHeight" class="wrapper">
  <div class="pictures-section-label uppercase">{{ label ? label : 'MEDIA:' }}</div>
  <div class="pictures-row flex flex-wrap gap-[20px]">
    @if (isEditable) {
      @if (add) {
        <div
          (click)="fileInputRef.nativeElement.click()"
          class="picture-block add-picture-block"
          >
          <div
            class="icon-container"
            >
            <mat-icon class="plus-icon" svgIcon="plus" />
          </div>
        </div>
      }
    }
    @for (picture of pictures; track picture) {
      <div class="picture-block">
        <mat-icon
          (click)="isEditable && deletePicture(picture)"
          [class.editable]="isEditable"
          class="delete-picture"
          svgIcon="trash"
          />
        @switch (picture?.['fileType']) {
          <!-- Picture -->
          @case ('picture') {
            <app-image
              (click)="appService.openCarousel($event, pictures, picture, isEditable)"
              [url]="getThumbUrl(picture)"
              class="each-picture"
              />
          }
          <!-- Video -->
          @case ('video') {
            <div (click)="appService.openCarousel($event, pictures, picture, isEditable)"
              [matTooltipDisabled]="picture?.preview_gif_url"
              [matTooltip]="!picture?.preview_gif_url ? 'Your video is still processing' : ''"
              class="media-container flex flex-row justify-center items-center"
              >
              <!-- Display image or GIF -->
              @if (loading) {
                <app-shimmer-loader
                  [appearance]="loaderAppearance"
                  [count]="1"
                  [theme]="loaderTheme"
                  class="loader"
                  />
              }
              <img
                (error)="handleError()"
                (load)="hideLoader()"
                [class.hidden]="loading"
                [src]="picture?.preview_gif_url || dummyUrl"
                alt="Media"
                class="image"
                >
              <!-- Show video length overlay if the fileType is video -->
              @if (picture?.fileType === 'video' && picture?.preview_gif_url) {
                <div class="video-length text-type-7">
                  {{ picture?.duration | videoDuration }}
                </div>
              }
            </div>
          }
          <!-- Document -->
          @case ('document') {
            <!--            <ng-container *ngIf="picture?.thumb_url;else docTemplate">-->
            @if (getThumbUrl(picture)) {
              <app-image
                (click)="appService.openCarousel($event, pictures, picture, isEditable)"
                [url]="getThumbUrl(picture)"
                class="each-picture"
                />
            } @else {
              <div
                (click)="appService.openCarousel($event, pictures, picture, isEditable)"
                class="each-document"
                >
                <span class="file-title">
                  {{ picture?.original_name }}
                </span>
              </div>
            }
          }
        }
      </div>
    }
  </div>
</div>
<input
  #fileInput
  (change)="onFileSelected($event)"
  [attr.accept]="accept || null"
  class="hidden"
  multiple
  type="file"
  />
